/* Shared by the editor preview and public article renderer. No authored scripts run. */
(function (root, factory) {
  if (typeof module === 'object' && module.exports) module.exports = factory();
  else root.UcleusVideo = factory();
})(typeof window !== 'undefined' ? window : this, function () {
  const css = `
    .ue-video-figure{margin:32px 0!important;max-width:100%}
    .ue-video-stage{position:relative;isolation:isolate;border-radius:20px;overflow:hidden;background:#e8e8ed;line-height:0}
    .ue-video-stage video{display:block!important;width:100%!important;max-width:100%;max-height:80vh;aspect-ratio:16/9;object-fit:contain;background:#e8e8ed!important;margin:0!important;border-radius:0!important}
    .ue-video-stage video::-webkit-media-controls,
    .ue-video-stage video::-webkit-media-controls-enclosure{display:none!important}
    .ue-video-play{position:absolute;bottom:20px;left:20px;display:grid;place-items:center;width:56px;height:56px;min-width:44px;min-height:44px;padding:0;border:0;border-radius:50%;background:rgba(255,255,255,.92);color:#68686d;cursor:pointer;box-shadow:0 1px 6px #00000008;backdrop-filter:blur(12px);transition:background .15s,transform .15s;z-index:1}
    .ue-video-play:hover{background:#fff;transform:scale(1.04)}
    .ue-video-play:focus-visible{outline:3px solid var(--ucleus-accent,#f7d135);outline-offset:-4px}
    .ue-video-play svg{width:20px;height:20px;display:block;fill:currentColor;pointer-events:none}
    .ue-video-play[hidden]{display:none}
    .ue-video-figure>figcaption{max-width:760px;margin:16px auto 0;padding:0 12px;font:500 14px/1.5 system-ui,sans-serif;color:var(--ucleus-text,#6e6e73);opacity:.8}
    .ue-video-error{font:14px/1.5 system-ui,sans-serif;margin:12px 0;color:var(--ucleus-text,#4b5563)}
    @media(max-width:600px){.ue-video-stage{border-radius:14px}.ue-video-play{width:48px;height:48px;bottom:12px;left:12px}.ue-video-figure>figcaption{padding:0;margin-top:12px}.ue-video-figure{margin:24px 0!important}}
    @media(prefers-reduced-motion:reduce){.ue-video-play{transition:none}}
  `;
  function enhance(doc) {
    if (!doc.getElementById('ue-video-style')) {
      const style = doc.createElement('style'); style.id = 'ue-video-style'; style.textContent = css; doc.head.append(style);
    }
    const cleanups = [];
    doc.querySelectorAll('video').forEach(video => {
      if (video.closest('[data-ue-player]')) return;
      const stage = doc.createElement('div');stage.className='ue-video-stage';stage.dataset.uePlayer='';stage.contentEditable='false';
      video.before(stage);stage.append(video);
      const figure=stage.closest('figure');if(figure)figure.classList.add('ue-video-figure');
      const button=doc.createElement('button');button.type='button';button.className='ue-video-play';button.dataset.ueRuntime='';
      const playIcon='<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 3.8c0-1 1.1-1.6 1.9-1.1l14 8.2c.8.5.8 1.7 0 2.2L7.9 21.3C7.1 21.8 6 21.2 6 20.2Z"/></svg>';
      const pauseIcon='<svg viewBox="0 0 24 24" aria-hidden="true"><rect x="5" y="3" width="5" height="18" rx="1.2"/><rect x="14" y="3" width="5" height="18" rx="1.2"/></svg>';
      const caption=figure?.querySelector('figcaption')?.textContent.trim();
      const paint=action=>{
        video.controls=false;video.removeAttribute('controls');
        button.hidden=false;button.innerHTML=action==='Pause'?pauseIcon:playIcon;
        button.setAttribute('aria-label',`${action} video${caption?`: ${caption}`:''}`);
      };
      paint('Play');stage.append(button);
      video.playsInline=true;video.preload='metadata';video.removeAttribute('autoplay');video.autoplay=false;
      video.disablePictureInPicture=true;video.disableRemotePlayback=true;
      const error=doc.createElement('p');error.className='ue-video-error';error.dataset.ueRuntime='';error.hidden=true;error.setAttribute('role','status');stage.after(error);
      const showError=()=>{error.textContent='This video could not be played. Press play to try again.';error.hidden=false;button.disabled=false;paint('Retry');};
      const togglePlayback=async()=>{
        if(!video.paused&&!video.ended){video.pause();return;}
        button.disabled=true;error.hidden=true;
        try{if(video.error)video.load();await video.play();}
        catch{showError();}
        finally{button.disabled=false;}
      };
      const playing=()=>{error.hidden=true;paint('Pause');};
      const paused=()=>paint(video.ended?'Replay':'Play');
      const ended=()=>{button.disabled=false;paint('Replay');};
      // One keyboard-accessible control handles play, pause and replay in place.
      button.addEventListener('click',togglePlayback);video.addEventListener('play',playing);video.addEventListener('pause',paused);video.addEventListener('ended',ended);video.addEventListener('error',showError);
      if(video.error)showError();
      cleanups.push(()=>{button.removeEventListener('click',togglePlayback);video.removeEventListener('play',playing);video.removeEventListener('pause',paused);video.removeEventListener('ended',ended);video.removeEventListener('error',showError);});
    });
    return ()=>cleanups.forEach(cleanup=>cleanup());
  }
  // Editor decorations are runtime-only: HTML mode and saved articles retain portable native video markup.
  function serialize(body) {
    const clone=body.cloneNode(true);
    clone.querySelectorAll('[data-ue-runtime]').forEach(node=>node.remove());
    clone.querySelectorAll('[data-ue-player]').forEach(stage=>{const video=stage.querySelector('video');if(video){video.controls=false;video.removeAttribute('controls');stage.replaceWith(video);}else stage.remove();});
    clone.querySelectorAll('video').forEach(video=>video.removeAttribute('controls'));
    return clone.innerHTML;
  }
  return { enhance, serialize };
});
